import { RootState } from "common/reducers";
import { createSelector } from "reselect";

const model = "signedDocuments";

/**
 * Loads byId key from signedDocuments
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {Map<number, SignedDocumentRecord>} Map<number, DocumentRecord>
 */
export const byId = (state: RootState, _props?: any) => state.getIn([model, "byId"]);

/**
 * Loads the signedDocument using id
 *
 * @param {RootState} state The RootState
 * @param {{ signedDocumentId: number }} options
 * @returns {DocumentRecord} DocumentRecord
 */
export const signedDocument = (state: RootState, props?: any) => byId(state).get(props.signedDocumentId);

/**
 * Checks if all recipients have signed the document
 *
 * @param {RootState} state The RootState
 *  @param {{ signedDocumentId: number }} options
 * @returns {boolean} boolean
 */
export const allSigned = createSelector([signedDocument], (sd) => {
  if (!sd) return false;

  const unsigned = sd.recipients.find((r) => {
    return r.status !== "recipient_signed";
  });

  return unsigned === undefined;
});

/**
 * Retrieves the current signed document ID
 *
 * @param {RootState} state The RootState
 * @returns {number} The current signed document ID
 */
export const currentSignedDocumentId = (state: RootState): number => state.getIn(["signedDocuments", "currentId"]);

/**
 * Retrieves the current signed document
 *
 * @param {RootState} state The RootState
 * @returns {SignedDocumentRecord | undefined} The current signed document or undefined if not found
 */
export const currentSignedDocument = createSelector([byId, currentSignedDocumentId], (byId, currentId) => {
  return byId.get(currentId);
});
